'use client';

import Link from "next/link";
import { usePathname } from "next/navigation";

export default function BlogLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const showBack = pathname !== '/blog';

  return (
    <main className="min-h-screen px-4">
      <div className="max-w-2xl mx-auto mt-12 sm:mt-20">
        {showBack && (
          <Link
            href="/blog"
            className="inline-flex items-center gap-2 text-sm text-amber-500 hover:text-amber-400 font-semibold mb-10 transition-colors"
          >
            ← All Articles
          </Link>
        )}

        {/* Prose styles for MDX content */}
        <article className="
          prose prose-invert max-w-none
          prose-headings:font-extrabold prose-headings:tracking-tight
          prose-h1:text-4xl prose-h1:text-white prose-h1:mb-4
          prose-h2:text-2xl prose-h2:text-white prose-h2:mt-10 prose-h2:mb-3
          prose-h3:text-xl prose-h3:text-slate-200
          prose-p:text-slate-300 prose-p:leading-relaxed
          prose-a:text-amber-400 prose-a:no-underline hover:prose-a:text-amber-300
          prose-strong:text-white
          prose-ul:text-slate-300 prose-li:marker:text-amber-500
          prose-blockquote:border-l-amber-500 prose-blockquote:text-slate-400
          prose-hr:border-amber-900/30
          pb-20
        ">
          {children}
        </article>
      </div>
    </main>
  );
}
